/**
 * The demo's "disk": files exist in this tab's memory only. An image a visitor
 * uploads is kept here and disappears with the tab.
 */
const files = new Map<string, Uint8Array>();

export const existsSync = (p: string): boolean => files.has(p) || p.startsWith('demo-file:');
export const mkdirSync = (): void => undefined;
export const writeFileSync = (p: string, bytes: Uint8Array): void => void files.set(p, bytes);
export function readFileSync(p: string): Uint8Array {
  const f = files.get(p);
  if (!f) throw new Error(`no such file: ${p}`);
  return f;
}
